define('main',[
    "jquery",
    "eventManager",
    "underscore",
    "score_ccf/moduleLoader",
    "scorebootstrap",
    "SageDotCom/DataLayer/tealium", // tealium initializer
    "SageDotCom/DataLayer/global", // global tracking
    'SageDotCom/DataLayer/Events/loginStart',
    "SageDotCom/PatternAnimations/animations",
    "SageDotCom/Components/CustomerZone",
    "SageDotCom/Utility/frontEnd",
    "SageDotCom/Utility/sageLoader",
    "ellipsis",
    "clamp",
    "slick",
    "vimeo_api"
], function (
    $,
    eventManager,
    _,
    moduleLoader,
    scorebootstrap,
    tealium,
    tracking,
    loginStartEvent,
    animations,
    CustomerZone,
    frontEnd,
    sageLoader
) {
    "use strict";

    window.getRandomNumber = function () {
        // Create byte array and fill with 1 random number between 0 and 256
        var byteArray = new Uint32Array(1);
        window.crypto.getRandomValues(byteArray);

        return (byteArray[0] / 2147483647);
    };

    window.DEBUG_TEALIUM = false;

    window.ALLOWED_IFRAME_ORIGINS = [
        "https://assets.sage.com",
        "https://assets.pp-sageimagine.com",
        "https://assets.qa-sageimagine.com",
        "https://assets.dev-sageimagine.com",
        "https://communityhub.sage.com",
        "https://pp-communityhub.sage.com",
        // Product Tour runtime
        "https://interactive.sage.com",
        "https://preprod.interactive.sage.com",
        "https://dev.interactive.sage.com"
    ];


    // add speculation rules (only for PP for now)
    if (
        HTMLScriptElement.supports &&
        HTMLScriptElement.supports("speculationrules")
    ) {
        var origin = window.location.origin;
        if (origin === "https://edit.pp-sageimagine.com" || origin === "https://web.pp-sageimagine.com") {
            const specScript = document.createElement("script");
            specScript.type = "speculationrules";
            const specRules = {
                "prefetch": [{
                    "urls": [
                        "/en-gb/sage-business-cloud/intacct/",
                        "/en-gb/size/small-business/",
                        "/en-gb/size/medium-sized-business/",
                        "/en-gb/human-resources/",
                        "/en-gb/sage-business-cloud/accounting/",
                        "/en-gb/sage-business-cloud/payroll/",
                        "/en-gb/accountants/",
                        "/en-gb/",
                        "/en-gb/about-us/contact-us/",
                        "/en-gb/sitemap/",
                        "/en-gb/support/",
                        "/en-gb/products/login/",
                        "/en-gb/medium/",
                        "/en-gb/products/sage-one/",
                        "/en-gb/products/sage-crm/",
                        "/en-gb/success-stories/phase-3/",
                        "/en-gb/sage-business-cloud/hr/",
                        "/en-gb/company/corporate-partnerships/six-nations-rugby/",
                        "/en-gb/company/events/",
                        "/en-gb/sage-champions/",
                        "/en-gb/products/sage-50-accounts/",
                        "/en-gb/sage-business-cloud/people/",
                        "/en-gb/company/careers/",
                        "/en-gb/products/",
                        "/en-gb/products/sage-50-payroll/",
                        "/en-gb/legal/privacy-and-cookies/",
                        "/en-gb/small-business/",
                        "/en-gb/legal/privacy/",
                        "/en-gb/company/careers/career-search/"
                    ],
                    "eagerness": "moderate"
                }]
            };
            specScript.textContent = JSON.stringify(specRules);
            document.body.append(specScript);
        }
    }

    // Cookies Banner
    eventManager.subscribe("close cookie banner", function () {
        //create cookie
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        var expires = "; expires=" + date.toUTCString();
        document.cookie = "sage_cookies_banner=1" + expires + "; path=/";

        //hide banner
        [].forEach.call(document.querySelectorAll('.cookies-banner, #cookiesbanner'), function (el) {
            el.style.display = 'none';
        });

        cookieBanner();
    });

    //prevents dropdown from closing when clicked inside
    document.addEventListener('click', function (e) {
        var links = [].slice.call(e.currentTarget.querySelectorAll('.score-megamenu .dropdown-menu, .subscription-header'));
        links.some(function (linkEl) {
            if (e.target.isSameNode(linkEl)) {
                e.stopPropagation();
                // basically foreach break;
                return !0;
            }
        });
    });

    // Set opacity to 1  on components after load to stop janky loading
    setTimeout(function () {
        [].forEach.call(document.querySelectorAll('.gallery-container, .article-collection, .commerce-page'), function (el) { el.style.opacity = '1'; });

        //stop carousel rotating
        $('.score-carousel').carousel('pause');
    }, 500);

    // e-commerce
    var productConfigFormEl = document.querySelector('.product-configuration .form-group .col');
    [].forEach.call(document.querySelectorAll('.commerce-page .product-configuration .row:first-child .col-4'), function (el) {
        productConfigFormEl.appendChild(el);
    }, this);


    [].forEach.call(document.querySelectorAll('.buy-summary .table'), function (el) {
        var divWrapper = document.createElement('div');
        divWrapper.className = 'table-responsive';
        el.parentNode.insertBefore(divWrapper, el);
        divWrapper.appendChild(el);
    }, this);


    //Header
    var navbarToggleEl = document.querySelector('header .navbar-toggle');
    if (navbarToggleEl) {
        navbarToggleEl.classList.add('collapsed');

        navbarToggleEl.addEventListener('click', function (e) {
            if (navbarToggleEl.classList.contains('collapsed')) {
                document.body.classList.add('menu-open');
            } else {
                document.body.classList.remove('menu-open');
            }
        });
    }

    // if you need to monkey patch anything in Score Bootstrap Initialization logic
    // here's where you would do it. Before calling to init(). Something like:
    // scorebootstrap.Accordion.init = function() { ... }

    // init SCORE Bootstrap components (Tabsets, Accordions, Carousels, etc.)
    scorebootstrap.init();

    // Checking for shared datasources
    if ($("body").hasClass("mode-experience-editor")) {
        $("code[kind='open'][hintname$='Multisite Shared']").each(function (i, el) {
            var actualElement = $(el).next("div.scEnabledChrome");
            if (actualElement.length === 1) {
                actualElement.addClass("shared-datasource");
                var sharedDatasourceBanner = document.createElement("div");
                $(sharedDatasourceBanner).addClass("shared-datasource-banner");
                $(sharedDatasourceBanner).text("This component uses a datasource in the Shared folder");

                var panelBody = actualElement.children(".panel-body");
                if (panelBody.length === 1) {
                    panelBody.prepend(sharedDatasourceBanner);
                }
                else {
                    actualElement.prepend(sharedDatasourceBanner);
                }
            }
        });
    }


    [].forEach.call(document.querySelectorAll('.score-megamenu-dropdown.products .score-accordion .panel-collapse'), function (el) { el.classList.remove('in'); });

    [].forEach.call(document.querySelectorAll('.score-accordion .score-accordion-panel, .tabAccordion-panel-accordion'), function (el) {
        // collapse all accordion and tabset accordion panels
        var button = el.querySelector('button[data-toggle="collapse"]');
        var panel = el.querySelector(".panel-collapse.collapse");

        if (button && panel) {
            button.classList.add('collapsed');
            button.setAttribute('aria-expanded', 'false');
            panel.classList.remove('in');
            panel.style.height = 0;
        }
    });

    [].forEach.call(document.querySelectorAll(".tabAccordion-panel-accordion:first-of-type button[data-toggle='collapse']"), function (el) {
        // open first tabset-accordion panel by default if it does not have collapse-first panel style applied
        if (!(el.closest(".vertical-tabAccordion").classList.contains("collapse-first-panel"))) {
            $(el).click();
        }
    });

    [].forEach.call(document.querySelectorAll(".score-accordion.open-first-panel > .score-accordion-panel:first-of-type .panel-title > button[data-toggle='collapse']"), function (el) {
        // open first accordion panel only if it has "open-first-panel" applied
        $(el).click();
    });

    frontEnd.preloadAsync()
        .then(function () {
            // TODO: move call of this code to frontEnd dependency
            CustomerZone.preload();
        })
        .then(function () {
            return new Promise(function (resolve, reject) {
                moduleLoader.loadPendingModules().done(resolve);
            });
        })
        .then(frontEnd.postloadAsync.bind(frontEnd))
        .then(function () {
            // initialize tealium once SCORE has loaded
            tracking.initialize();
            tealium.initialize();
            animations.initialize();
            CustomerZone.postload();
            sageLoader.initialize();

            $(".privacy-rights-request-form .form-next-btn").prop('disabled', true);
            $(".score-style-box.privacy-rights-request").find(".progress-bar-holder .progress-bar-button").prop('disabled', true);

            [].forEach.call(document.querySelectorAll('.customer-stories-card'), function (el) {
                var styleBox = el.parentNode;
                if (!(styleBox.classList.contains('score-style-box') && styleBox.classList.contains('panel-box'))) { return; } //if missing these classes skip
                //styleBox.setAttribute('tabindex','0');
                styleBox.addEventListener('keyup', function (event) {
                    if (event.keyCode === 13) {
                        var link = styleBox.querySelector('a');
                        if (link && link.parentNode.classList.contains('sage-modal-button')) {
                            link.click();
                        } else {
                            var url = link.getAttribute("href");

                            if (url == null) {
                                return;
                            }
                            window.location.href = url;
                        }
                    }
                });
                var wrappingDiv = document.createElement('div');
                wrappingDiv.className = 'zoom-wrapper';
                styleBox.parentNode.insertBefore(wrappingDiv, styleBox);
                wrappingDiv.appendChild(styleBox);
            });

            //show cookies banner
            var cookieBannerEl = document.getElementById('cookiesbanner');
            if (cookieBannerEl)
                cookieBannerEl.style.display = 'block';

            cookieBanner();

            // Enabling tabbing slick dots via key navigation
            // Enabling tabbing for navigation tabs
            [].forEach.call(document.querySelectorAll('.article-collection .slick-dots li button, .nav.nav-tabs .nav-tab button:not(.bypasstabindex)'), function (el) { el.setAttribute('tabindex', '0'); });

            $("body").on("keyup", ".nav.nav-tabs .nav-tab", function (event) {
                if (event.keyCode === 37 || event.keyCode === 39) {
                    //if within a slick slider, logic needs to be slightly different
                    var slickTrack = $(event.currentTarget).closest(".slick-track");
                    function getPreviousTab() {
                        if (slickTrack.length === 0) {
                            var prevTab = $(event.currentTarget).prev(".nav.nav-tabs .nav-tab");

                            if (prevTab.length === 0) {
                                //find the last tab and select that
                                prevTab = $(event.currentTarget).nextAll(".nav.nav-tabs .nav-tab").last();
                            }

                            return prevTab;
                        }
                        else {
                            var currentSlickIndex = Number($(event.currentTarget).closest(".slick-slide").attr('data-slick-index'));
                            //if index is 0 or less, is first tab, so find last
                            if (currentSlickIndex <= 0) {
                                return slickTrack.find(".slick-slide:not(.slick-cloned) .nav-tab").last();
                            }
                            else {
                                var nextindex = currentSlickIndex - 1;
                                return slickTrack.find(".slick-slide[data-slick-index='" + nextindex + "'] .nav-tab");
                            }
                        }
                    }

                    function getNextTab() {
                        if (slickTrack.length === 0) {
                            var nextTab = $(event.currentTarget).next(".nav.nav-tabs .nav-tab");

                            if (nextTab.length === 0) {
                                //find the last tab and select that
                                nextTab = $(event.currentTarget).prevAll(".nav.nav-tabs .nav-tab").last();
                            }

                            return nextTab;
                        }
                        else {
                            var currentSlickIndex = Number($(event.currentTarget).closest(".slick-slide").attr('data-slick-index'));
                            var nextindex = currentSlickIndex + 1;
                            var nextTab = slickTrack.find(".slick-slide[data-slick-index='" + nextindex + "']:not(.slick-cloned) .nav-tab");
                            if (nextTab.length === 0) {
                                //was the last tab, so select the first
                                nextTab = slickTrack.find(".slick-slide[data-slick-index='0'] .nav-tab");
                            }

                            return nextTab;
                        }
                    }

                    var link;

                    if (event.keyCode == 37) {
                        //left
                        var prevTab = getPreviousTab();

                        if (prevTab.length !== 0) {
                            link = prevTab.find("button");
                        }
                    }
                    if (event.keyCode == 39) {
                        //right
                        var nextTab = getNextTab();

                        if (nextTab.length !== 0) {
                            link = nextTab.find("button");
                        }
                    }

                    if (link !== undefined && link.length !== 0) {
                        link.focus();                        
                        //Timeout to prevent non-active tabs having a tabindex
                        setTimeout(function () {
                            if (slickTrack.length === 0) {
                                return;
                            }

                            slickTrack.find(".nav-tab:not(.active) button.nav-tab-btn").attr("tabindex", "-1");
                            slickTrack.find(".nav-tab.active button.nav-tab-btn").attr("tabindex", "0");

                            //Make sure focused tab is in view
                            var slider = link.closest(".slick-slide");
                            if (slider.length === 0) {
                                return;
                            }
                            var offset = slider.offset().left;
                            if (offset !== 0 && (offset > 1 || offset < -1)) {
                                //even with scroll into view, still not in view
                                //need to extract the x value from the translate 3d
                                var transform = slider.closest(".slick-track").css("transform").replace(/[^0-9\-.,]/g, '').split(",");
                                if (transform.length > 0) {
                                    var translateX = Number(transform[12] || transform[4]);
                                    if (translateX !== 0) {
                                        var newLeft = translateX - slider.offset().left;
                                        slider.closest(".slick-track").css("transition", "transform ease 500ms");
                                        slider.closest(".slick-track").css("transform", "translate3d(" + newLeft + "px, 0, 0)");
                                    }
                                }
                            }
                        }, 500);
                    }
                }
                if (event.keyCode === 9) {
                    setTimeout(function () {
                        //Make sure focused tab is in view
                        var slider = $(event.currentTarget).closest(".slick-slide");
                        if (slider.length === 0) {
                            return;
                        }
                        var offset = slider.offset().left;
                        if (offset !== 0 && (offset > 1 || offset < -1)) {
                            //even with scroll into view, still not in view
                            //need to extract the x value from the translate 3d
                            var transform = slider.closest(".slick-track").css("transform").replace(/[^0-9\-.,]/g, '').split(",");
                            if (transform.length > 0) {
                                var translateX = Number(transform[12] || transform[4]);
                                if (translateX !== 0) {
                                    var newLeft = translateX - slider.offset().left;
                                    slider.closest(".slick-track").css("transition", "transform ease 500ms");
                                    slider.closest(".slick-track").css("transform", "translate3d(" + newLeft + "px, 0, 0)");
                                }
                            }
                        }
                    }, 500);
                }
            });

            updateCustomerStorySlidesWithImages();

            //ecommerce - hide links on SAC - todo: improve that method
            var hideOnSacTriggerEl = document.getElementById('hideOnSacTrigger');
            if (hideOnSacTriggerEl) {
                [].forEach.call(document.querySelectorAll('.hide-on-sac'), function (el) { el.style.display = 'none'; });
            }
        });

    /*
     * Sitecore issue with SC 9 Forms - Language Fix
     */
    [].forEach.call(document.querySelectorAll('form'), function (el) {
        var attrAction = el.getAttribute("action");
        if (attrAction !== null && typeof attrAction !== typeof undefined && attrAction !== false) {
            if (attrAction.indexOf("formbuilder") >= 0) {
                if (attrAction.indexOf("sc_lang=") < 0) {
                    var sep = "?";
                    if (attrAction.indexOf("?") > 0) {
                        sep = "&";
                    }

                    var u = window.location.href;
                    var s = u.split("/");

                    if (s.length >= 4) {
                        var lang = s[3];

                        var findLang = 4;
                        while (lang == "" && s.length >= findLang + 1) {
                            lang = s[findLang];
                            findLang++;
                        }

                        //hard coded - TODO: Find the language in a different place
                        if (lang && lang.toLowerCase() === "investors")
                            lang = "en-gb";

                        if (lang && lang.toLowerCase() === "africa")
                            lang = "en-zw";

                        if (lang && lang.toLowerCase() === "en-ae")
                            lang = "en-tv";

                        if (/^.{2,3}-.{2}$|^.{2}-.{4}-.{2}$/.test(lang))
                            el.setAttribute("action", attrAction + sep + "sc_lang=" + lang);
                    }
                }
            }
        }
    });

    eventManager.subscribe("toggle search box", function () {
        if (document.body.classList.contains('grey-out')) {
            document.body.classList.remove('grey-out');
            [].forEach.call(document.querySelectorAll('.search-header-stripe .sage-funnelback-search-box'), function (el) { el.classList.remove('open'); });
        } else {
            document.body.classList.add('grey-out');
            [].forEach.call(document.querySelectorAll('.search-header-stripe .sage-funnelback-search-box'), function (el) { el.classList.add('open'); });
        }
    });

    //TODO MODAL INTO VANILLA JS
    // Reposition when a modal is shown
    $("body").on("show.bs.modal", ".modal", reposition);

    //search filter collapsed
    [].forEach.call(document.querySelectorAll('.funnelback-refine-btn'), function (el) {
        el.addEventListener('click', function (e) {
            e.stopPropagation();
            [].forEach.call(document.querySelectorAll('.js-funnelback-facets-list'), function (el) { el.classList.toggle('open'); });
        });
    });

    [].forEach.call(document.querySelectorAll('.funnelback-return-btn'), function (el) {
        el.addEventListener('click', function (e) {
            e.stopPropagation();
            [].forEach.call(document.querySelectorAll('.dropdown-menu'), function (el) { el.classList.remove('slide-left'); });
            [].forEach.call(document.querySelectorAll('.js-funnelback-facets-list'), function (el) { el.classList.remove('open'); });
        });
    });

    //:not doesnt accept more than 1 class in IE for pure JS
    $(document).on("click", ".js-funnelback-facets-list .score-facet-row:not(.sage-video-listing-facet .score-facet-row, .show-all, .show-less)", function () {
        $(".js-funnelback-facets-list").removeClass("open");
        return false;
    });

    //Adding wrapper for facets-list black overlay background
    $(".js-funnelback-facets-list-wrapper").wrap("<div class='inner-wrapper'></div>");
    $(".sage-video-listing-facet .js-funnelback-facets-list").wrapInner("<div class='inner-wrapper'></div>");


    // file upload customization for non gated forms to match styling requirements
    [].forEach.call(document.querySelectorAll('.file-upload-input'), function (el) {
        el.addEventListener('change', function (e) {
            var filename = el.value.split("\\").pop();
            var parentEl = el.parentNode; // go level up and then search down for the element
            var uploadEl = parentEl.querySelector('.uploaded-file-name-label');
            if (uploadEl)
                uploadEl.textContent = filename;
        });
    });

    //TODO CHECK IF STILL USED
    [].forEach.call(document.querySelectorAll('.clear-non-gated-form'), function (el) {
        el.addEventListener('click', function (e) {
            [].forEach.call(document.querySelectorAll('form'), function (formEl) { formEl.reset(); });
            [].forEach.call(document.querySelectorAll('.uploaded-file-name-label'), function (inputEl) { inputEl.textContent = 'No file chosen' });
        });
    });

    eventManager.subscribe("partner-search-contact-form", function (email) {
        var contactEmailEl = document.querySelector('.contact-partner-email');
        if (contactEmailEl)
            contactEmailEl.value = email;
    });


    $('#skip-links-container .skip-links').on('click', function (e) {
        var mainContent = $('.page-wrapper');
        var firstVisibleChild;
        if ($(mainContent).children() != null) {
            var mainContentChildren = $(mainContent).children();
            for (var i = 0; i < mainContentChildren.length; i++) {
                if ($(mainContentChildren[i]).css('display') != 'none') {
                    firstVisibleChild = $(mainContentChildren[i])
                    break;
                }
            }
            e.preventDefault();
            $(this).blur();
            $('html, body').animate({ scrollTop: mainContent.offset().top }, 250);
            $(firstVisibleChild).attr("tabindex", "-1").focus();
        }
    });

    var buySumElement = document.querySelector('.commerce-page .sticky-lg .buy-summary legend');

    if (buySumElement) {
        var topOfDiv = $(".commerce-page .sticky-lg .buy-summary legend").offset().top; //gets offset of header
        var height = buySumElement.clientHeight; //gets height of header

        $(window).on("resize", function () {
            //Refresh values
            topOfDiv = $(".commerce-page .sticky-lg .buy-summary legend").offset().top; //gets offset of header
            height = buySumElement.clientHeight; //gets height of header
        });

        document.addEventListener('scroll', function () {
            if (document.body.clientWidth >= 1460 && window.innerHeight >= 1020) {
                if (window.pageYOffset > (topOfDiv + height)) {
                    [].forEach.call(document.querySelectorAll('.commerce-page .sticky-lg'), function (el) {
                        el.classList.add('sticky-scroll');
                        el.classList.remove('sticky-non-scroll');
                    });
                } else {
                    [].forEach.call(document.querySelectorAll('.commerce-page .sticky-lg'), function (el) {
                        el.classList.remove('sticky-scroll');
                        el.classList.add('sticky-non-scroll');
                    });
                }
            } else if (document.body.clientWidth < 1460 || window.innerHeight < 1020) {
                [].forEach.call(document.querySelectorAll('.commerce-page .sticky-lg'), function (el) { el.classList.remove('sticky-scroll'); });
            }
        });
    }

    [].forEach.call(document.querySelectorAll('.info-banner'), function (el) {
        var divWrapper = document.createElement('div');
        divWrapper.className = 'info-banner-wrapper';
        var elemToWrap = el.parentNode; //Needs to be parent of info-banner as it is in a full width container
        elemToWrap.parentNode.insertBefore(divWrapper, elemToWrap);
        divWrapper.appendChild(elemToWrap);
    }, this);

    getReferrerPage();

    var pageEl = document.querySelector('link[rel="canonical"]');
    if (pageEl) {
        var pageUrl = pageEl.getAttribute('href');

        if (pageUrl && pageUrl.indexOf("sage-200") >= 0 && pageUrl.indexOf("sign-up") >= 0) {
            storeEmailAddress();
        }

        if (pageUrl && pageUrl.indexOf("sage-200") >= 0 && pageUrl.indexOf("success") >= 0) {

            var stepOne = document.querySelector('.step-1');
            if (stepOne) {
                stepOne.classList.remove('progress-bar-current');
                [].forEach.call(document.querySelectorAll('.step-1, .step-2, .step-3'), function (el) { el.classList.add('progress-bar-completed'); });
                [].forEach.call(document.querySelectorAll('.step-1, .step-2'), function (el) { el.setAttribute('disabled', 'true'); });
                [].forEach.call(document.querySelectorAll('.step-3'), function (el) { el.removeAttribute('disabled', 'false'); });
            }

            var encodedEmailAddress = sessionStorage.getItem("encodedEmailAddress");
            if (encodedEmailAddress) {
                sessionStorage.removeItem("encodedEmailAddress");
                var decodedEmail = atob(encodedEmailAddress);
                var swapMeEl = document.querySelector(".swap-me");
                if (decodedEmail && swapMeEl) {
                    swapMeEl.textContent = decodedEmail;
                }
            }
        }
    }

    [].forEach.call(
        document.querySelectorAll(
            ".score-iframe.sage-city, .score-iframe.roi-iframe, .score-iframe.iframe-resizer"
        ),
        function (el) {
            const currentUrl = new URL(window.location.href);
            const query = currentUrl.searchParams.get("ProductId");
            const scoreIframeChildrenEl = el.children;

            // Make iframes responsive & append ProductId
            if (scoreIframeChildrenEl) {
                for (let i = 0; i < scoreIframeChildrenEl.length; i++) {
                    const iframe = scoreIframeChildrenEl[i];
                    if (!iframe) continue;

                    iframe.classList.add("responsive-iframe");

                    if (query) {
                        const separator = iframe.src.includes("?") ? "&" : "?";
                        iframe.src += separator + "ProductId=" + query;
                    }
                }
            }

            (function () {
                // Debug helpers
                const log = (...args) => window.DEBUG_TEALIUM === true && console.log("[tealium]", ...args);
                const warn = (...args) => window.DEBUG_TEALIUM === true && console.warn("[tealium]", ...args);

                const allowed = new Set(window.ALLOWED_IFRAME_ORIGINS);

                log("Allowed origins:", Array.from(allowed));

                // Tealium queue
                const queue = [];
                function callUtag(action, data) {
                    if (!window.utag) {
                        warn("utag not ready, queuing", { action, data });
                        queue.push({ action, data });
                        return;
                    }
                    if (queue.length) {
                        queue.splice(0).forEach(({ action: a, data: d }) => callUtag(a, d));
                    }
                    if (action === "view" && window.utag.view) return window.utag.view(data);
                    if (action === "link" && window.utag.link) return window.utag.link(data);
                    if (window.utag.track) return window.utag.track(action, data);
                    warn("No handler for action:", action, data);
                }

                function normalise(payload, action) {
                    return Object.assign(
                        { tealium_event: payload.tealium_event || action, event_action: action },
                        payload
                    );
                }

                // Initialize iFrameResizer
                iFrameResize(
                    {
                        messageCallback: ({ iframe, message, origin }) => {
                            const fallbackOrigin =
                                origin || (iframe && iframe.src ? new URL(iframe.src).origin : null);

                            if (!fallbackOrigin || !allowed.has(fallbackOrigin)) {
                                warn("[msg] Blocked message from disallowed origin:", origin, {
                                    message, iframe, fallbackOrigin
                                });
                                return;
                            }

                            if (!message || typeof message !== "object") {
                                log("[msg] Ignoring non-object message:", { message, iframe, origin, fallbackOrigin });
                                return;
                            }

                            const clickBySelector = (selector) => {
                                const sel = String(selector || "").trim();
                                if (!sel) {
                                    warn("[click] Missing selector in message");
                                    return;
                                }
                                const el = document.querySelector(sel);
                                if (!el) {
                                    warn("[click] Selector not found:", sel);
                                    return;
                                }
                                if (typeof el.click !== "function") {
                                    warn("[click] Element does not support .click():", sel);
                                    return;
                                }
                                el.click();
                                log("[click] Dispatched native click for selector:", sel);
                            };

                            switch (message.type) {
                                case "tealium:event": {
                                    const action = String(message.action || "").toLowerCase();
                                    const data = normalise(message.data || {}, action);
                                    log("[tealium] Dispatching event:", { action, data, origin, fallbackOrigin, iframe });
                                    callUtag(action, data);
                                    break;
                                }
                                case "click:selector": {
                                    clickBySelector(message.selector);
                                    break;
                                }
                                case "request:parent-url": {
                                    const reply = {
                                        type: "parent:url",
                                        origin: window.location.origin,
                                        pathname: window.location.pathname
                                    };

                                    log("[msg] Replying with parent url:", reply);
                                    iframe.iFrameResizer.sendMessage(reply);
                                    break;
                                }
                                default:
                                    log("[msg] Ignoring message of unknown type:", { message, origin, fallbackOrigin, iframe });
                            }
                        }
                    },
                    ".responsive-iframe"
                );



                // Flush queue when utag loads
                (function waitForUtag() {
                    if (window.utag) {
                        queue.splice(0).forEach(({ action, data }) => callUtag(action, data));
                    } else {
                        setTimeout(waitForUtag, 200);
                    }
                })();
            })();
        }
    );

    function getReferrerPage() {
        var referrerUrl = document.referrer;
        var currentHost = window.location.origin;
        if (referrerUrl) {
            if (currentHost && referrerUrl.indexOf(currentHost) === -1) {
                var referrerDomain = referrerUrl.match(/:\/\/(.[^/]+)/)[1];
                if (referrerDomain) {
                    sessionStorage.setItem("referrer_domain", referrerDomain);
                }
            }
        }
    }
    //SAGE 200 TRIAL FORM Confirmation Email
    function storeEmailAddress() {
        var emailInputEl = document.querySelector(".product-trial-content input[id$='Email']");
        if (emailInputEl) {
            var emailAddress = emailInputEl.value;
            if (emailAddress && !sessionStorage.getItem("encodedEmailAddress")) {
                var hashedEmailAddress = btoa(emailAddress);
                sessionStorage.setItem("encodedEmailAddress", hashedEmailAddress);
            }
        }
    }

    //Vertically center Bootstrap 3 modals so they aren't always stuck at the top
    function reposition() {
        var modalEl = this;
        if ($(modalEl).hasClass("product-card-feature-modal")) {
            return;
        }
        var dialogEl = modalEl.querySelector('.modal-dialog');
        modalEl.style.display = 'block';
        // Dividing by two centers the modal exactly, but dividing by three
        // or four works better for larger screens.
        dialogEl.style.marginTop = Math.max(0, (window.innerHeight - dialogEl.clientHeight) / 2) + "px";
    }

    // This will add the background image if it doesn't exist as a style attribute
    // because the slick slider will remove style tags for each slide
    function updateCustomerStorySlidesWithImages() {
        [].forEach.call(document.querySelectorAll('.customer-stories-card'), function (el) {
            var scoreStyleBox = el.parentNode;
            var imgToUse = scoreStyleBox.getAttribute('data-img');
            if (imgToUse) {
                scoreStyleBox.style.backgroundImage = "url('" + imgToUse + "')";
            }
        });
    }

    function cookieBanner() {
        var cookieBannerEl = document.querySelector('.cookies-banner');
        if (!cookieBannerEl) {
            document.body.style.paddingTop = 0;
            return;
        }

        // store the state before override it
        cookieBannerEl._olddisplay = cookieBannerEl.style.display || '';
        cookieBannerEl.style.display = 'block';
        var cookieBannerHeight = cookieBannerEl.offsetHeight;
        // restore the state
        cookieBannerEl.style.display = cookieBannerEl._olddisplay;

        document.body.style.paddingTop = cookieBannerHeight + "px";
    }

    // new header logic
    // hamburger 
    var navbarToggleEl = document.querySelector('header .navbar-toggle');
    if (navbarToggleEl) {
        // add initial state
        navbarToggleEl.classList.add('collapsed');

        navbarToggleEl.addEventListener('click ', function (e) {
            if (navbarToggleEl.classList.contains('collapsed')) {
                document.body.classList.add('menu-open');
            } else {
                document.body.classList.remove('menu-open');
            }
        });
    }

    function CalculateMenuPosition(dropdown) {
        if (!window.BrainJocks.EE) {
            if (!$('.score-header').hasClass('collapsed')) {
                $(dropdown).addClass('open');
                $(dropdown).children().first().attr('aria-expanded', 'true');
                if ($(dropdown).hasClass('center-positioned')) {

                    var mmWidth = $('header .score-megamenu').parent().width();

                    var listItemWidth = $(dropdown)[0].offsetWidth;
                    var listItemLeft = $(dropdown)[0].offsetLeft;
                    var ddlMenuEl = $(dropdown).find('.dropdown-menu');
                    if (ddlMenuEl) {
                        // offsetWidth can be taken only from a visible element.
                        var dropdownMenu = ddlMenuEl[0].offsetWidth;
                        if ((listItemLeft + listItemWidth / 2 + dropdownMenu / 2) >= mmWidth) {
                            var pushMargin = (mmWidth - dropdownMenu) / 2;
                        } else {
                            var pushMargin = listItemLeft + listItemWidth / 2 - dropdownMenu / 2 + 24;
                        }

                        ddlMenuEl.css('marginLeft', pushMargin + 'px');
                    }
                }
            }
        }
    }

    // adjust button group styling
    //add theme-dark to top level button groups
    $('header .navbar-collapse > .score-button-group').addClass('theme-dark');


    // allow custom logo from media library in cp header
    if ($("header").hasClass("cp-nav-header")) {
        var customLogos = $("header.cp-nav-header .navbar-collapse .score-image-button.cp-header-logo");
        if (customLogos !== null && customLogos !== undefined && customLogos.length > 0) {
            var defaultLogo = $(".score-header .score-megamenu .score-nav-wrapper .score-nav .navbar-header.score-navbar-header .navbar-brand");
            customLogos.each(function () {
                // use for each as there may be different logos depending on screen size
                $(this).insertAfter(defaultLogo);
            });
        }
    }
    

    // desktop: open DD menu on hover
    // and  calculate DD menu position
    $('header .score-megamenu .score-megamenu-dropdown')
        .on('mouseenter', function (e) {
            CalculateMenuPosition($(this));
        })
        .on('mouseleave', function () {
            if (!$('.score-header').hasClass('collapsed')) {
                $(this).removeClass('open');
                $(this).children().first().attr('aria-expanded', 'false');
            }
        });

    $('header .score-megamenu .score-megamenu-dropdown > a, header .score-megamenu .score-megamenu-dropdown > button')
        .on('click touch', function (e) {
            // mobile
            e.preventDefault();
            var isOpen = $(this).parent(".score-megamenu-dropdown").hasClass('open');
            if ($('.score-header').hasClass('collapsed')) {
                var parentLi = $(this).parent();
                if (parentLi.hasClass("menu-tabset-inside")) {
                    // contains menu tabset so just show the buttons related to tabset rather than opening panel
                    var menuTabsetId = parentLi.find(".menu-tabSet-container").parent().attr("data-attr-id");
                    var relatedMobileButtons = parentLi.siblings('[data-related-menutabset-id="' + menuTabsetId + '"]');

                    var isExpanded = $(this).attr('aria-expanded') === "true";
                    isExpanded ? relatedMobileButtons.hide() : relatedMobileButtons.show();
                    $(this).attr('aria-expanded', isExpanded ? "false" : "true");
                }
                else {
                    parentLi.addClass('open');
                    $(this).attr('aria-expanded', 'true');
                }
            }
            else {
                // desktop (for screen readers only)
                //Original event is only present on e when using a screen reader
                if (e.originalEvent) {
                    var elNav = $(this).parent(".score-megamenu-dropdown");
                    if (isOpen) {
                        $(elNav).removeClass('open');
                        $(elNav).children().first().attr('aria-expanded', 'false');
                    }
                    else {
                        CalculateMenuPosition(elNav);
                    }
                }
            }
            e.stopPropagation();
        });

    //back button
    // add needed element to back button
    $('<span class="bottom-line"></span>').appendTo('.back-button');
    $('.back-button').attr('tabindex', '0');
    // close submenu and clean up
    $('header .score-megamenu .back-button')
        .on('click touch', function (e) {
            var closeParent = $(this).closest('.score-megamenu-dropdown');
            closeParent.removeClass('open');
            if (!closeParent.hasClass("menu-tabset-inside")) {
                closeParent.find('a:first-child').attr('aria-expanded', 'false');
            }
        })
        .on("keydown", function (e) {
            if (e.which == 13) {
                var closeParent = $(this).closest('.score-megamenu-dropdown');
                closeParent.removeClass('open');
                if (!closeParent.hasClass("menu-tabset-inside")) {
                    closeParent.find('a:first-child').attr('aria-expanded', 'false');
                }
            }
        });

    function showSearchHideNavbarContent() {
        $('.sage-search-mobile').addClass('open')
            .find(".js-funnelback-search-button, .search-term-input:not(.tt-hint), .close-search")
            .attr("tabindex", "0");

        $("header.score-header")
            .find(
                ".score-hamburger, .score-megamenu-basic-item > a, .score-megamenu-dropdown > a,  .score-megamenu-dropdown > button, .score-image-button.search, .sage-modal-button .modal-launch-btn")
            .attr("tabindex", "-1");
        $('.sage-search-mobile')
            .find(".search-term-input:not(.tt-hint)").focus();
    }

    function hideSearchShowNavbarContent() {
        $('.sage-search-mobile').removeClass('open')
            .find(".js-funnelback-search-button, .search-term-input:not(.tt-hint), .close-search")
            .attr("tabindex", "-1");
        $("header.score-header")
            .find(
                ".score-hamburger, .score-megamenu-basic-item > a, .score-megamenu-dropdown > a, .score-megamenu-dropdown > button, .score-image-button.search, .sage-modal-button .modal-launch-btn")
            .attr("tabindex", "0");
    }

    // add screenreader functionality to search icon
    $('.score-image-button.search').attr("aria-label", "Search");

    // prevent tabnabbing on buttons that point to external page
    $("a[target='_blank']").attr("rel", "noopener noreferrer");

    // Header search open
    $('.score-image-button.search').on('click', function () {
        showSearchHideNavbarContent();
    });
    // close search on click outside
    $('.page-wrapper').on('click touch', function () {
        hideSearchShowNavbarContent();
    });

    $('header .sage-search-mobile').on('click', '.close-search', function () {
        hideSearchShowNavbarContent();
    });

    hideSearchShowNavbarContent();

    // save header widths for latter calculations
    let globalNavWidth = 0;
    let globalNeededNavWidth = 0;

    function initHeaderWidths() {
        // header is visible, so all LI widths are correct
        $('header .navbar-nav >li:not([data-related-menutabset-id])').each(function () {
            globalNavWidth += $(this).width() + 40;
        });
        $('header .navbar-collapse > .score-button-group').each(function () {
            globalNavWidth += $(this).width() + 60;
        });
        // needed width nav + needed papdding 40*2 + logo + structure padding
        globalNeededNavWidth = globalNavWidth + 80 + 60 + 48;
    }
    // do it now
    initHeaderWidths();

    [].forEach.call(document.querySelectorAll('header .score-megamenu .score-megamenu-dropdown'), function (elNav) {
        elNav.addEventListener('keyup', function (e) {
            var keyCode = e.keyCode || e.which;
            var isOpen = $(elNav).hasClass('open');
            if (keyCode == 13 || keyCode == 32 || (isOpen && keyCode === 27)) {
                if (isOpen) {
                    if (!$('.score-header').hasClass('collapsed')) {
                        $(elNav).removeClass('open');
                        $(elNav).children().first().attr('aria-expanded', 'false');
                    }
                } else {
                    CalculateMenuPosition($(elNav));
                    this.addEventListener("focusout", function () {
                        setTimeout(function () {
                            var hasFocus = $(elNav).find(':focus').length > 0;
                            if (!hasFocus) {
                                if (!$('.score-header').hasClass('collapsed')) {
                                    $(elNav).removeClass('open');
                                    $(elNav).children().first().attr('aria-expanded', 'false');
                                }
                            }
                        }, 10);
                    });
                }
            }
        });
    }, this);

    // add collapsed to header if there is no space 
    // for all header links
    function checkHeader() {
        var outerW = $(window).width();
        var $headerEl = $('.score-header');
        var stickyNav = document.querySelector(".sticky-nav");
        if ((outerW < globalNeededNavWidth) || (outerW <= 1080)) {
            // !do not add collapsed if in EE!
            if (!$headerEl.hasClass('collapsed') && !window.BrainJocks.EE) {
                $headerEl.addClass('collapsed');
                if (stickyNav) {
                    stickyNav.classList.add("collapsed");
                    [].forEach.call(stickyNav.querySelectorAll('.score-megamenu-dropdown, .score-megamenu-basic-item'), function (el) {
                        el.classList.add("navCollapsed");
                    });
                }
                $('header .score-megamenu + .score-button-group').addClass('header-group-positioned');
            }
        } else {
            if ($headerEl.hasClass('collapsed')) {
                $headerEl.removeClass('collapsed');
                // clean-up mobile toggle
                $('body').removeClass('menu-open');
                if (stickyNav) {
                    stickyNav.classList.remove("collapsed");
                    [].forEach.call(stickyNav.querySelectorAll('.score-megamenu-dropdown, .score-megamenu-basic-item'), function (el) {
                        el.classList.remove("navCollapsed");
                    });
                }

                $('header .navbar-toggle').addClass('collapsed');
                $('header .navbar-toggle').attr('aria-expanded', 'false');
                $('header .navbar-collapse.collapse').removeClass('in');
                $('header .score-megamenu + .score-button-group').removeClass('header-group-positioned');
            }
        }
        eventManager.trigger("control-menu-tabset-button-visibility");
    }

    function readdSlickNavigationClasses() {
        // re-add removed slick-slider navigation classes so slick-dots and slick-arrow still appear after resizing

        $('body:not(.animations-off) .slick-slider .slick-arrow').addClass("lazy-animated--finished");
        $('body:not(.animations-off) .slick-slider .slick-arrow').attr("animate-processed", true);

        $('body:not(.animations-off) .slick-slider .slick-dots').addClass("lazy-animated--finished");
        $('body:not(.animations-off) .slick-slider .slick-dots').attr("animate-processed", true);
    }

    // resize functions go here
    var checkResizeMain = function () {
        checkHeader();
        cookieBanner();
    };

    $(window).resize(function () {
        clearTimeout(window.resizedFinishedMain);
        window.resizedFinishedMain = setTimeout(function () {
            checkResizeMain();
            readdSlickNavigationClasses();
        }, 250);
    });

    checkResizeMain();      // initializes cookieBanner

    //remove animations on exp editor
    if ($("body").hasClass("mode-experience-editor")) {
        $("body").addClass("animations-off");
    }

    //clickable card
    $(".clickable-card").each(function () {
        var card = $(this);
        //make the card entirely clickable
        card.click(function () {
            var buttonContainer = card.find(".score-call-to-action")[0];
            if (typeof buttonContainer !== "undefined") {
                //case: Modal button
                var modalContainer = $(buttonContainer).children(".sage-modal-button")[0];
                if (typeof modalContainer !== "undefined") {
                    var modalBtn = $(modalContainer).children(".modal-launch-btn")[0];
                    if (typeof modalBtn !== "undefined") {
                        modalBtn.click();
                    }
                }
                //case: Generic link
                var genericLink = $(buttonContainer).children(".score-button")[0];
                if (typeof genericLink !== "undefined") {
                    var btnClass = $(genericLink).attr("class");

                    //check btnclass has a values and contains login-trigger
                    if (btnClass && btnClass.indexOf("login-trigger") > -1) {
                        //trigger login_start event 
                        var data = loginStartEvent.GenerateEventMetadata(genericLink);
                        tealium.event(data);
                    }

                    var href = $(genericLink).attr("href");
                    if (href != null) {
                        var target = $(genericLink).attr("target");
                        if (target != null) {
                            window.open(href, target);
                        } else {
                            window.location = href;
                        }
                    }
                }
            }
        });

        //if the button is set to open a video in a lightbox, add a video play button
        if (card.hasClass("video-lightbox")) {
            card.prepend('<div class="video-play-button"></div>');
        }

        //if the button is set to open a video in a lightbox, add a video play button
        if (card.hasClass("download-lightbox")) {
            card.prepend('<div class="download-button"></div>');
        }

        //If they are clickable, then they should get keyboard focus
        if (card.attr("tabindex") === undefined) {
            card.attr("tabindex", "0");
            card.on("keypress", function (event) {
                if (event.keyCode === 13) {
                    card.click();
                }
            });
        }
    });

    var sliderObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
            // never unobserve or disconnect as we may need the code to run several times as the component can be shown/hidden again and again
            var isHidden = entry.contentRect.height == 0 || entry.contentRect.width == 0;
            if (!isHidden) {
                var slider = $(entry.target);
                if (slider.hasClass("slick-initialized")) {
                    var currentSlideIndex = slider.slick("slickCurrentSlide");
                    slider.slick("slickGoTo", currentSlideIndex);
                }
            }
        });
    });

    [].forEach.call(document.querySelectorAll('.score-slick-slider, .score-carousel'), function (slider) {
        sliderObserver.observe(slider);
    });
});
